export default __webpack_public_path__ + "static/media/5.ef87e794.png";